module.exports = __webpack_public_path__ + "img/hdyy_details_1.a1c183b0.png";